import {JSONAttrs} from './types';

const isVimeoVideo = (url?: string) =>
  /^(?:https?:\/\/)?(?:www\.)?(?:vimeo\.com\/)([0-9]+)/.test(url ?? '');

const isYouTubeVideo = (url?: string) =>
  /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})(?:\S+)?$/.test(
    url ?? '',
  );

const getYouTubeVideoId = (url: string) => {
  const videoIdMatch = url.match(
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
  );
  return videoIdMatch ? videoIdMatch[1] : null;
};

const getVimeoVideoId = (url: string) => {
  const videoIdMatch = url.match(/^(?:https?:\/\/)?(?:www\.)?(?:vimeo\.com\/)([0-9]+)/);
  return videoIdMatch ? videoIdMatch[1] : null;
};

const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_APP_GOOGLE_MAPS_API_KEY;
function convertToEmbedLink(url: string): string {
  try {
    if (!url) return '';
    // remove the @ from the start of the URL if it exists
    const cleanUrl = url.startsWith('@') ? url.substring(1) : url;

    // For shortened URLs of maps.app.goo.gl
    //this case is for SHORT SHARE URLS from maps, currently not working
    if (cleanUrl.includes('maps.app.goo.gl')) {
      // Extract the unique identifier
      const locationId = cleanUrl.split('/').pop();
      // Use the identifier to construct the embed URL
      return `https://www.google.com/maps/embed/v1/search?key=${GOOGLE_MAPS_API_KEY}&q=${locationId}`;
    }

    // If it's not a maps.app.goo.gl URL, use it directly as a search query
    return `https://www.google.com/maps/embed/v1/search?key=${GOOGLE_MAPS_API_KEY}&q=${encodeURIComponent(
      cleanUrl,
    )}`;
  } catch (error) {
    console.error('Error converting map URL:', error);
    return '';
  }
}

function getTextAlign(attrs?: JSONAttrs) {
  if (!attrs?.textAlign) return 'left';
  return attrs.textAlign;
}

export {
  isVimeoVideo,
  isYouTubeVideo,
  getYouTubeVideoId,
  getVimeoVideoId,
  convertToEmbedLink,
  getTextAlign,
};
